export default [
  800,
  780,
  760,
  752,
  745,
  746,
  735,
  711,
  695,
  681,
  658,
  642,
  627,
  613,
  601,
  592,
  572,
  552,
  534,
  513,
  504,
  486,
  469,
  468,
  456,
  445,
  430,
  419,
  415,
  402,
  388,
  375,
  373,
  360,
  348,
  341,
  331,
  322,
  314,
  308,
  300,
  290,
  277,
  271,
  264,
  262,
  255,
  250,
  245,
  240,
  233,
  229,
  223,
  216,
  212,
  208,
  203,
  199,
  191,
  190,
  186,
  183,
  180,
  175,
  170,
  167,
  166,
  163,
  160,
  156,
  154,
  149,
  147,
  143,
  141,
  139,
  137,
  135,
  131,
  127,
  121,
  116,
  114,
  111,
  107,
  105,
  103,
  95,
  90,
  81,
  76,
];
